import { render } from "./vagentplusfans.vue?vue&type=template&id=372d5df7&scoped=true"
import script from "./vagentplusfans.vue?vue&type=script&lang=js"
export * from "./vagentplusfans.vue?vue&type=script&lang=js"

import "./vagentplusfans.vue?vue&type=style&index=0&id=372d5df7&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372d5df7"]])

export default __exports__